import { isWorldlinePreprod } from '@packages/shared';

// ANZ Worldline preprod doesn't take real payments, so lower the amount to $1 for testing.
export const getPaymentAmountCents = (worldlineHost: string) =>
  isWorldlinePreprod(worldlineHost) ? 100 : 10000;
